import React, { useEffect, useState ,useContext} from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../../../assets/css/customer/screens/home/BlogSection.css";
import EsBlogCard from "../../../components/customer/blog/EsBlogCard";

// const blogs = [
//   {
//     id: 1,
//     date: "May 02, 2026",
//     readTime: "4 min read",
//     title: "5 Skincare Basics Every Patient Should Follow",
//     desc: "Cleanse, treat, hydrate, protect — the routine our dermatologists recommend.",
//     image: "https://images.unsplash.com/photo-1556228578-0d85b1a4d571?w=600&q=80",
//   },
//   {
//     id: 2,
//     date: "Apr 21, 2026",
//     readTime: "5 min read",
//     title: "Is Laser Hair Removal Safe? What to Expect",
//     desc: "A clear, dermatologist-backed look at how modern laser systems work.",
//     image: "https://images.unsplash.com/photo-1609840114035-3c981b782dfe?w=600&q=80",
//   },
//   {
//     id: 3,
//     date: "Apr 10, 2026",
//     readTime: "3 min read",
//     title: "Hydration: The Most Underrated Glow Hack",
//     desc: "Why drinking water and using the right humectants changes your skin.",
//     image: "https://images.unsplash.com/photo-1547592180-85f173990554?w=600&q=80",
//   },
// ];

const EstaticeBlog = (blog) => {
    const [blogs, setBlogs] = useState([]);
  return (
    <section className="ac-blog">
      <Container className="ac-blog__container">

        {/* Header */}
        <div className="ac-blog__header">
          <div className="ac-blog__header-left">
            <span className="ac-blog__label">FROM OUR BLOG</span>
            <h2 className="ac-blog__heading">Skin care insights</h2>
          </div>
          <span className="ac-blog__view-all">
            All posts
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          </span>
        </div>

        {/* Cards Row */}
        <Row className="ac-blog__row">
          {blogs.map((post) => (
            <EsBlogCard Blog={blog}/>
            // <Col lg={4} md={4} sm={12} key={post.id} className="ac-blog__col">
            //   <div className="ac-blog__card">
            //     {/* Image */}
            //     <div className="ac-blog__img-wrap">
            //       <img
            //         src={post.image}
            //         alt={post.title}
            //         className="ac-blog__img"
            //       />
            //     </div>
            //     {/* Body */}
            //     <div className="ac-blog__body">
            //       <span className="ac-blog__meta">
            //         {post.date} &nbsp;·&nbsp; {post.readTime}
            //       </span>
            //       <h5 className="ac-blog__title">{post.title}</h5>
            //       <p className="ac-blog__desc">{post.desc}</p>
            //     </div>
            //   </div>
            // </Col>
          ))}
        </Row>

      </Container>
    </section>
  );
};

export default EstaticeBlog;